module.exports = __webpack_public_path__ + "img/idcard_fanmian.900f2cd2.png";